import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query GenerationToolRatings($generationTool: GenerationToolEnum!, $projectId: ID!) {
    generationToolRatings(generationTool: $generationTool, projectId: $projectId)
  }
`;

export const generationToolRatings = ({ generationTool, projectId }) => {
  const variables = { generationTool, projectId };

  return executeGqlQuery({
    query: QUERY,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
